const upcoming = [
    {
        id:0,
        title:'SARFIRA',
        type:'Drama',
        lang:'Hindi',
        src:'https://originserver-static1-uat.pvrcinemas.com/pvrcms/movie_v/29312_byxn1hEE.jpg'
    },
    {
        id:1,
        title:'KILL',
        type:'Action',
        lang:'Hindi English',
        src:'https://assets-in.bmscdn.com/discovery-catalog/events/tr:w-400,h-600,bg-CCCCCC:w-400.0,h-660.0,cm-pad_resize,bg-000000,fo-top:l-text,ie-NSwgSnVsIDIwMjQ%3D,fs-29,co-FFFFFF,ly-612,lx-24,pa-8_0_0_0,l-end/et00374797-gfldqaccfv-portrait.jpg'
    },
    {
        id:2,
        title:'MAHARAJA',
        type:'Action',
        lang:'Hindi',
        src:'https://assets-in.bmscdn.com/iedb/movies/images/mobile/thumbnail/xlarge/maharaja-hindi-et00402946-1719504211.jpg'
    },
    {
        id:3,
        title:'CHANDU CHAMPION',
        type:'Sports',
        lang:'Hindi',
        src:'https://originserver-static1-uat.pvrcinemas.com/pvrcms/movie_v/28553_1SgDvpUh.jpg'
    },
]


export default upcoming;